import { Component, OnInit } from "@angular/core";
import { CareerformComponent } from "../careerform/careerform.component";
import { MatDialog } from "@angular/material/dialog";
import { ShareService } from "src/app/service/share.service";
import { kesariAnimations } from "src/app/animation";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: "app-careerpage",
  templateUrl: "./careerpage.component.html",
  styleUrls: ["./careerpage.component.scss"],
  animations: kesariAnimations
})
export class CareerpageComponent implements OnInit {
  careerInfo: any;
  metaData = {
    isProduct: false,
    page: "MICE-CAREER"
  }
  constructor(public dialog: MatDialog, private miceService: ShareService,private meta: Meta, private title: Title) { }

  ngOnInit(): void {
    this.getCareerInfo();
  }
  getCareerInfo() {
    this.miceService.getCareerInfo().subscribe(data => {
      this.careerInfo = data
    })
    this.miceService.getMetaData(this.metaData).subscribe((data) => {
      // console.log(data)
      if (data.length != 0) {
        this.meta.updateTag({ property: 'og:title', content: data[0].meta_title });
        this.meta.updateTag({ name: 'keywords', content: data[0].meta_keyword });
        this.meta.updateTag({ name: 'description', content: data[0].meta_description });
        this.title.setTitle(data[0].meta_title);
        // console.log(data[0].meta_description)
      }

    })
    this.miceService.setCanonicalURL();
  }
  openDialog() {
    this.dialog.open(CareerformComponent, {
      width: "900px",
      disableClose: true,
      hasBackdrop: true
    });
  }
}
